import { SanityImage } from 'src/components/atoms/SanityImage'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { TeamMemberQueryResult } from 'src/server/router/sanity/groq/teamMembers/types'

const MemberCardRebrand = ({ data }: { data: TeamMemberQueryResult }) => {
  if (!data.image) return null
  return (
    <div className='flex flex-col gap-2 lg:gap-5'>
      <SanityImage
        alt={data.name || 'Member'}
        className='w-full aspect-square object-cover'
        source={data.image}
        width={400}
        height={400}
        sourceHeight={400}
        sourceWidth={400}
      />
      <div className='flex flex-col gap-2'>
        <TypographyRebrand variant='h4' color='forestDeep'>
          {data.name}
        </TypographyRebrand>
        <TypographyRebrand variant='introduction' color='forestDeep'>
          {data.title}
        </TypographyRebrand>
      </div>
    </div>
  )
}

export default MemberCardRebrand
